import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import RacingThemeRoot from '../RacingThemeRoot/RacingThemeRoot';
import RacingThemeSearchBannerInput from './RacingThemeSearchBannerInput';
import RacingThemeSearchBannerTabs from './RacingThemeSearchBannerTabs';
import RacingThemeSearchBannerButton from './RacingThemeSearchBannerButton';
import { SEARCH_BANNER_DEFAULTS } from '../RacingThemeSearch/searchResultsContent';
import styles from './RacingThemeSearchBanner.module.css';

/**
 * Search results banner — composes input, channel tabs, and submit button.
 */
const RacingThemeSearchBanner = props => {
  const {
    query = SEARCH_BANNER_DEFAULTS.query,
    placeholder = SEARCH_BANNER_DEFAULTS.placeholder,
    tabs = SEARCH_BANNER_DEFAULTS.tabs,
    activeTab = SEARCH_BANNER_DEFAULTS.activeTab,
    onQueryChange,
    onSubmit,
    onTabChange,
  } = props;

  const [draftQuery, setDraftQuery] = useState(query);

  useEffect(() => {
    setDraftQuery(query);
  }, [query]);

  const handleSubmit = () => {
    if (typeof onSubmit === 'function') {
      onSubmit(draftQuery);
    }
  };

  return (
    <RacingThemeRoot className={styles.searchBannerRoot}>
      <div className={styles.searchBanner}>
        <div className={styles.searchBannerInner}>
          <div className={styles.searchBarRow}>
            <RacingThemeSearchBannerInput
              value={draftQuery}
              placeholder={placeholder}
              readOnly={typeof onSubmit !== 'function'}
              onChange={event => {
                const next = event.target.value;
                setDraftQuery(next);
                if (typeof onQueryChange === 'function') {
                  onQueryChange(next);
                }
              }}
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  handleSubmit();
                }
              }}
            />
            <RacingThemeSearchBannerTabs
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={onTabChange}
            />
            <RacingThemeSearchBannerButton onClick={handleSubmit} />
          </div>
        </div>
      </div>
    </RacingThemeRoot>
  );
};

RacingThemeSearchBanner.propTypes = {
  query: PropTypes.string,
  placeholder: PropTypes.string,
  tabs: PropTypes.array,
  activeTab: PropTypes.string,
  onQueryChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onTabChange: PropTypes.func,
};

export default RacingThemeSearchBanner;
